import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import firebase from "../../Firebase";
import { Modal as Modals, Button as Buttons, Menu, Dropdown, Icon, message, Tooltip } from "antd";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import StatusTag from "../../components/StatusTag/StatusTag";
import TableLegend from "../../components/TableLegend/TableLegend";
import EditPasswordModal from "../../components/Modal/EditPasswordModal";
import DeletionSummaryModal from "../../components/Modal/DeletionSummaryModal";
import { cortes, costura, acabado, almacen } from "variables/DataTable.jsx";
import "./ConsultaComercial.scss";

class RegularTables extends React.Component {
  constructor() {
    super();
    this.state = {
      datos: [],
      loading: true,
      prof: "",
      op: [],
      ft: [],
      profsp: [],
      modalIsOpen: false,
      password: "",
      doc: "",
      cliente: "",
      op2: "",
      fechaIngreso: "",
      fechaSalida: "",
      pcpData: [],
      setFiles: [],
      allfiles: "",
      visible: false,
      propagation: false,
      colors: null,
      modalTitleProf: "",
      modalTitleOp: "",
      deleteModalIsOpen: false,
      targetProf: null,
      expanded: {},
      editModalVisible: false,
    };
  }

  async loadData() {
    await firebase
      .firestore()
      .collection("comercial")
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        const data = querySnapshot.docs.reduce((acc, data) => {
          const colores = data.data().otros.map((v) => v.color);

          const getStatus = data
            .data()
            .otros.every((item) => item.acabado && item.acabado.fechaSalida);
          const item = data.data();
          const itemIndex = acc.findIndex(
            (accItem) => accItem.prof === item.prof,
          );
          const colorList = (item.otros && item.otros.length) ? item.otros : [];
          const detalles = colorList.reduce((ac, v) => {
            ac.push({
              color: v.color,
              estilo: v.estilo,
              cant: v.cant,
              estado:
                v.acabado && v.acabado.fechaSalidaLiq
                  ? "Liquidado"
                  : v.acabado && v.acabado.fechaSalida
                    ? "Despachado"
                    : v.acabado
                      ? "Acabado"
                      : v.costura
                        ? "Costura"
                        : v.corte
                          ? "Corte"
                          : v.telas
                            ? v.telas.tEstado
                            : "PCP",
              telas: v.telas ? [v.telas] : [],
              corte: v.corte ? [v.corte] : [],
              costura: v.costura ? [v.costura] : [],
              acabado: v.acabado ? [v.acabado] : [],
              almacen: v.almacen ? [v.almacen] : [],
            });
            return ac;
          }, []);

          // Refined Priority Logic (Merging Legacy + Dynamic)
          let swifts = item.swifts && Array.isArray(item.swifts) ? [...item.swifts] : [];
          
          if (item.sw30Files && item.sw30Files[0] && (!swifts[0] || !swifts[0].url)) {
            const legacy0 = { name: "SWIFT 1", url: item.sw30Files[0] };
            if (swifts.length > 0) swifts[0] = legacy0; else swifts.push(legacy0);
          }
          if (item.sw70Files && item.sw70Files[0] && (!swifts[1] || !swifts[1].url)) {
            const legacy1 = { name: "SWIFT 2", url: item.sw70Files[0] };
            if (swifts.length === 0) swifts.push({ name: "SWIFT 1", url: "" });
            if (swifts.length > 1) swifts[1] = legacy1; else swifts.push(legacy1);
          }

          let newItem = [{}];
          if (itemIndex >= 0) {
            newItem = {
              ...acc[itemIndex],
              otros: acc[itemIndex].otros.concat({
                prof: item.prof,
                op: item.op,
                b: item.b,
                descripcion:
                  colorList && colorList.length ? colorList[0].descripcion : [],
                estilo:
                  colorList && colorList.length ? colorList[0].estilo : [],
                fichaTecnica: item.fichaTecnica,
                f: item.f,
                states: (item.otros && item.otros.length)
                  ? getStatus
                    ? "Completo"
                    : "Pendiente"
                  : "Pendiente",
                edit: {
                  doc: item.index || data.id,
                  prof: item.prof,
                  cliente: item.cliente,
                  fechaIngreso: item.cFechaIngreso,
                  fechaSalida: item.cFechaEntrega,
                  isEditable: !item.isEditable,
                  a: item.a && item.a.length ? item.a[0] : "",
                  profsp: item.profsp && item.profsp.length ? item.profsp[0] : "",
                  swifts, // Pass unified array
                },
                detalles,
              }),
            };
            acc.splice(itemIndex, 1, newItem);
          } else {
            newItem = {
              cFechaIngreso: item.cFechaIngreso,
              prof: item.prof,
              a: item.a[0] ? item.a[0] : [],
              profsp: item.profsp,
              swifts, // Dynamic array for icons
              cliente: item.cliente,
              cFechaEntrega: item.cFechaEntrega,
              states: (item.otros && item.otros.length)
                ? getStatus
                  ? "Completo"
                  : "Pendiente"
                : "Pendiente",
              edit: {
                doc: item.index || data.id,
                prof: item.prof,
                cliente: item.cliente,
                fechaIngreso: item.cFechaIngreso,
                fechaSalida: item.cFechaEntrega,
                isEditable: !item.isEditable,
                a: item.a && item.a.length ? item.a[0] : "",
                profsp: item.profsp && item.profsp.length ? item.profsp[0] : "",
                swifts, // Pass unified array
              },
              value: [
                item.index,
                item.op,
                colores,
                item.prof,
                !item.isEditable,
              ],
              otros: [
                {
                  prof: item.prof,
                  op: item.op,
                  b: item.b,
                  descripcion:
                    colorList && colorList.length
                      ? colorList[0].descripcion
                      : [],
                  estilo:
                    colorList && colorList.length ? colorList[0].estilo : [],
                  fichaTecnica: item.fichaTecnica,
                  f: item.f,
                  states: (item.otros && item.otros.length)
                    ? getStatus
                      ? "Completo"
                      : "Pendiente"
                    : "Pendiente",
                  edit: {
                    doc: item.index || data.id,
                    prof: item.prof,
                    cliente: item.cliente,
                    fechaIngreso: item.cFechaIngreso,
                    fechaSalida: item.cFechaEntrega,
                    isEditable: !item.isEditable,
                    a: item.a && item.a.length ? item.a[0] : "",
                    profsp: item.profsp && item.profsp.length ? item.profsp[0] : "",
                    swifts, // Pass unified array
                  },
                  detalles,
                },
              ],
            };
            acc.push(newItem);
          }
          return acc;
        }, []);
        this.setState({ data, loading: false });
      });
  }

  componentDidMount() {
    this.loadData();
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  onDeleteSuccess = () => {
    const newData = this.state.data.filter((item) => item.prof !== this.state.targetProf);
    this.setState({
      data: newData,
      deleteModalIsOpen: false,
      targetProf: null,
    });
  };

  borrar = (value) => {
    // This is the old single-OP delete, kept for reference or if used elsewhere
    // but the main table now calls prepBorrar
    const id = value[0];
    const op = value[1];

    firebase.firestore().collection("comercial").doc(id).delete();

    firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          firebase.firestore().collection("ing").doc(doc.id).delete();
        });
      });

    var contador = 0;
    var lista = this.state.data;
    lista.map((registro) => {
      const idReg = registro.value[0];
      if (idReg === id) {
        lista.splice(contador, 1);
      }
      contador++;
      return registro;
    });
    this.setState({ data: lista });
  };

  openModal = (value) => {
    this.setState({
      modalIsOpen: true,
      doc: value[0],
      prof: value[1],
      cliente: value[2],
      fechaIngreso: value[3],
      fechaSalida: value[4],
      isEditable: value[5],
      a: value[6],
      profsp: value[7],
      sw30F: value[8],
      sw70F: value[9],
      swift30: value[10],
      swift70: value[11],
    });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  linkToEdit = (e) => {
    e.preventDefault();
    this.state.password === "pcpedit246."
      ? this.props.history.push({
          pathname: "/Comercial/EditComercial",
          state: {
            doc: this.state.doc,
            prof: this.state.prof,
            cliente: this.state.cliente,
            fechaIngreso: this.state.fechaIngreso,
            fechaSalida: this.state.fechaSalida,
            isEditable: this.state.isEditable,
            a: this.state.a,
            profsp: this.state.profsp,
            sw30F: this.state.sw30F,
            sw70F: this.state.sw70F,
            swift30: this.state.swift30,
            swift70: this.state.swift70,
          },
        })
      : message.error("Contraseña incorrecta, Vuelva intentarlo");
  };

  render() {
    const { data, loading, modalTitleOp, modalTitleProf } = this.state;

    const legendItems = [
      { type: 'file-text', className: 'doc-icon-factura', label: 'Factura Proforma' },
      { type: 'file-done', className: 'doc-icon-proforma-sp', label: 'Factura Proforma (Sin Precio)' },
      { type: 'dollar', className: 'doc-icon-payment', label: 'Pagos / Swift' },
      { type: 'file-pdf', className: 'doc-icon-op', label: 'Orden de Prod.' },
      { type: 'file-search', className: 'doc-icon-ft', label: 'Ficha Técnica' },
    ];

    const columns = [
          {
            Header: "Fecha Inicio",
            headerStyle: { fontWeight: "bold" },
            minWidth: 100,
            accessor: "cFechaIngreso",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cFechaIngreso" }],
              }),
            filterAll: true,
          },
          {
            Header: "Factura Proforma",
            headerStyle: { fontWeight: "bold" },
            accessor: "prof",
            minWidth: 140,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "prof" }],
              }),
            filterAll: true,
          },
          {
            Header: "Cliente",
            headerStyle: { fontWeight: "bold" },
            accessor: "cliente",
            minWidth: 150,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cliente  " }],
              }),
            filterAll: true,
          },
          {
            Header: "Archivos",
            headerStyle: { fontWeight: "bold" },
            minWidth: 100,
            sortable: false,
            filterable: false,
            Cell: (row) => (
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                {row.original.a && (
                  <Tooltip title="Factura Proforma">
                    <a href={row.original.a} target="_blank" rel="noopener noreferrer">
                      <Icon type="file-text" className="doc-icon-factura" style={{ fontSize: '18px' }} />
                    </a>
                  </Tooltip>
                )}
                {row.original.profsp && (
                  <Tooltip title="Factura Proforma (Sin Precio)">
                    <a href={row.original.profsp} target="_blank" rel="noopener noreferrer">
                      <Icon type="file-done" className="doc-icon-proforma-sp" style={{ fontSize: '18px' }} />
                    </a>
                  </Tooltip>
                )}
                {row.original.swifts && row.original.swifts.map((s, idx) => (
                  s.url && (
                    <Tooltip title={s.name || `SWIFT ${idx + 1}`} key={idx}>
                      <a href={s.url} target="_blank" rel="noopener noreferrer">
                        <Icon type="dollar" className="doc-icon-payment" style={{ fontSize: '18px' }} />
                      </a>
                    </Tooltip>
                  )
                ))}
              </div>
            ),
          },

          {
            Header: "Fecha Despacho",
            minWidth: 120,
            headerStyle: { fontWeight: "bold" },
            accessor: "cFechaEntrega",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cFechaEntrega" }],
              }),
            filterAll: true,
          },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            minWidth: 100,
            accessor: "states",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ["states"] }),
            filterAll: true,
            Cell: (row) => <StatusTag status={row.value} />,
          },
          {
            Header: "Acciones",
            headerStyle: { fontWeight: "bold" },
            width: 120,
            accessor: "actions",
            sortable: false,
            filterable: false,
            Cell: (row) => {
              const menu = (
                <Menu>
                  <Menu.Item 
                    key="edit" 
                    onClick={() => this.setState({ editModalVisible: true, targetProf: row.original.edit })}
                  >
                    Editar
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item 
                    key="delete" 
                    onClick={() => this.setState({ deleteModalIsOpen: true, targetProf: row.original.prof })}
                    style={{ color: 'red' }}
                  >
                    Borrar
                  </Menu.Item>
                </Menu>
              );

              return (
                <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                  <Buttons 
                    className="actions-btn"
                    icon="more" 
                    size="small" 
                    style={{ 
                      fontSize: '18px', 
                      color: 'rgba(0, 0, 0, 0.45)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto',
                      borderColor: '#e8e8e8',
                      borderRadius: '4px'
                    }}
                  />
                </Dropdown>
              );
            },
          },
    ];
    const subComercial1 = [
          {
            Header: "Orden de Producción",
            headerStyle: { fontWeight: "bold" },
            accessor: "op",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "op" }],
              }),
            filterAll: true,
          },
          {
            Header: "Ficha Técnica",
            headerStyle: { fontWeight: "bold" },
            accessor: "fichaTecnica",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "fichaTecnica",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Archivos",
            headerStyle: { fontWeight: "bold" },
            minWidth: 80,
            sortable: false,
            filterable: false,
            Cell: (row) => (
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                {row.original.b && row.original.b.length > 0 && (
                  <Tooltip title="Orden de Producción">
                    <a href={row.original.b} target="_blank" rel="noopener noreferrer">
                      <Icon type="file-pdf" className="doc-icon-op" style={{ fontSize: '18px' }} />
                    </a>
                  </Tooltip>
                )}
                {row.original.f && row.original.f.length > 0 && (
                  <Tooltip title="Ficha Técnica">
                    <a href={row.original.f} target="_blank" rel="noopener noreferrer">
                      <Icon type="file-search" className="doc-icon-ft" style={{ fontSize: '18px' }} />
                    </a>
                  </Tooltip>
                )}
              </div>
            ),
          },
          {
            Header: "Descripcion",
            headerStyle: { fontWeight: "bold" },
            accessor: "descripcion",
          },
          {
            Header: "Estilo",
            headerStyle: { fontWeight: "bold" },
            accessor: "estilo",
          },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            minWidth: 100,
            accessor: "states",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ["states"] }),
            filterAll: true,
            Cell: (row) => <StatusTag status={row.value} />,
          },
          {
            Header: "Acciones",
            headerStyle: { fontWeight: "bold" },
            width: 115,
            accessor: "edit",
            sortable: false,
            filterable: false,
            Cell: (row) => {
              const menu = (
                <Menu>
                  <Menu.Item 
                    key="details" 
                    onClick={() => {
                      this.setState({
                        visible: true,
                        colors: row.original.detalles,
                        modalTitleOp: row.original.op,
                        modalTitleProf: row.original.prof,
                      });
                    }}
                  >
                    Ver Detalles
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item 
                    key="edit" 
                    onClick={() => this.setState({ editModalVisible: true, targetProf: row.value })}
                  >
                    Editar
                  </Menu.Item>
                </Menu>
              );

              return (
                <div className="text-center">
                  <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                    <Buttons 
                      className="actions-btn"
                      icon="more" 
                      size="small" 
                    />
                  </Dropdown>
                </div>
              );
            },
          },
    ];

    const subComercial2 = [
          {
            Header: "Color",
            headerStyle: { fontWeight: "bold" },
            accessor: "color",
          },
          {
            Header: "Cantidad",
            headerStyle: { fontWeight: "bold" },
            accessor: "cant",
          },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            accessor: "estado",
            Cell: (row) => (
              <div className="text-center">
                <StatusTag status={row.value} />
              </div>
            ),
          },
    ];

    const telasDetalle = [
      {
        Header: "TELAS",
        headerStyle: { backgroundColor: "#F5BC66", color: "white", fontWeight: "bold" },
        columns: [
          { Header: "Fecha Inicio", headerStyle: { fontWeight: "bold" }, accessor: "tFechaIngreso" },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            accessor: "tEstado",
            Cell: (row) => (
              <div className="text-center">
                <StatusTag status={row.value} />
              </div>
            ),
          },
        ],
      },
    ];

    return (
      <div className="content">
        <Modals
          data={data}
          title={`Pof: "${modalTitleProf}" | OP: "${modalTitleOp}"`}
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={700}
          centered={true}
        >
          <ReactTable
            data={this.state.colors}
            columns={subComercial2}
            defaultPageSize={10}
            SubComponent={(row) => {
              return (
                <div style={{ padding: "10px" }}>
                  <ReactTable
                    data={row.original.telas}
                    columns={telasDetalle}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.corte}
                    columns={cortes}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.costura}
                    columns={costura}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.acabado}
                    columns={acabado}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.almacen}
                    columns={almacen}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0 40px 0" }}
                  />
                </div>
              );
            }}
          />
        </Modals>
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="text-center">
                  Seguimiento de Procesos Comercial
                </CardTitle>
              </CardHeader>
              <CardBody>
                <TableLegend items={legendItems} />
                <ReactTable
                  data={data}
                  noDataText="Sin Registros"
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value
                  }
                  columns={columns}
                  defaultPageSize={10}
                  className="-striped -highlight"
                  style={{ textAlign: "center" }}
                  previousText="Atras"
                  nextText="Siguiente"
                  pageText="Pagina"
                  ofText="de"
                  rowsText="filas"
                  minRows={0}
                  loading={loading}
                  expanded={this.state.expanded}
                  onExpandedChange={(newExpanded) =>
                    this.setState({ expanded: newExpanded })
                  }
                  SubComponent={(row) => {
                    return (
                      <div className="subrow-container">
                        <ReactTable
                          data={row.original.otros}
                          columns={subComercial1}
                          noDataText="No hay informacion"
                          pageSize={row.original.otros.length}
                          showPagination={false}
                          className="-striped -highlight"
                          style={{
                            textAlign: "center",
                          }}
                          minRows
                        />
                      </div>
                    );
                  }}
                />
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <EditPasswordModal
          visible={this.state.editModalVisible}
          onCancel={() => this.setState({ editModalVisible: false })}
          targetPath="/comercial/EditComercial"
          history={this.props.history}
          passData={this.state.targetProf}
        />

        <DeletionSummaryModal
          visible={this.state.deleteModalIsOpen}
          prof={this.state.targetProf}
          onCancel={() => this.setState({ deleteModalIsOpen: false })}
          onDeleteSuccess={this.onDeleteSuccess}
        />
      </div>
    );
  }
}

export default RegularTables;
